
import { Component } from "react";
// import ImageService from "../shared/ImageService";
import { connect } from "react-redux";
import { fetchImages } from "../../asyncActions/image.async.action";
import beerlineStyles from "./beerLine.module.css";
class BeerLine extends Component {
    title = 'Our Work Galery';
    constructor(props) {
        super(props);

        this.state = {
            images: [],
            grid: [],
        }

        this.handleMouseOver = this.handleMouseOver.bind(this);
    }

    genGrid() {
        if (this.props.imageState.images) {
            const rows = [];
            for (let i = 0; i < this.props.imageState.images.length; i += 4) {
                rows.push(this.props.imageState.images.slice(i, i + 4));
            }
            this.setState((prevState) => ({
                images: this.props.imageState.images,
                grid: rows,
            }));
        }

    }

    handleMouseOver(event) {
        if (event.target.classList.contains('card-img-top')) {
            const cardBody = event.target.parentElement.querySelector('.card-body');
            cardBody.classList.remove('visually-hidden');
        }
    }

    handleMouseLeave(event) {
        if (event.target.classList.contains('card-body')) {
            event.target.classList.add('visually-hidden');
        } else {
            event.target.querySelector('.card-body').classList.add('visually-hidden')
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.imageState !== this.props.imageState) {
            this.genGrid();
        }
    }

    componentDidMount() {
        this.props.fetchImages();

    }
    customBeerLine() {
        return (
            <div className={`${beerlineStyles.slide3_bg} d-flex`}>
                <div className={`${beerlineStyles.dark_transparent_screen} d-flex`}>
                    <div className={`${beerlineStyles.center} container`}>
                        <div className={`text-light ${beerlineStyles.padding_mobile}`}>
                            <h3 class="mt-5 fs-4 text-uppercase">Pour with confidence</h3>
                            <h1 class="display-2 fw-bolder text-capitalize">{this.title}</h1>
                            <div class="py-5">
                                <p class="fs-5">
                                    Let our expert beerline service keep your brews tasting fresh and delicious.
                                </p>
                                <div class="fs-2">
                                    {/* <img src={mrDraftLogoGif} class="img-md img-fluid" alt="Mr-Draft animated logo"/> */}
                                    <span>Call us today at</span>
                                    <a className={`ms-2 link-light`} href="tel:3476666818">
                                        (347)-666-6818
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    pictureList() {
        return (
            <ul class="container text-center">
                {
                    this.state.grid?.map((row, index) => (
                        <li class="row mt-5" key={`beerline-row-${index}`}>
                            <ul className={`${beerlineStyles.inner_list}`}>
                                {
                                    row.map((image, subIndex) => (
                                        <li key={`row-${index}-picture-${subIndex}`} className={`col-sm ${beerlineStyles.inner_list_item}`}>
                                            <div
                                                onMouseOver={(e) => this.handleMouseOver(e)}
                                                onMouseLeave={(e) => this.handleMouseLeave(e)}
                                                key={`beerline-col-${subIndex}`}
                                                className={`card ${beerlineStyles.mr_draft_card}`}>
                                                <img src={`/assets/images/pictures/${image}`} className={`card-img-top ${beerlineStyles.mr_draft_card_img}`} alt="This is a built tower" />
                                                <div className={`card-body visually-hidden ${beerlineStyles.mr_draft_card_text}`}>
                                                    <p className={`card-text m-auto`}>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                                </div>
                                            </div>
                                        </li>
                                    ))
                                }
                            </ul>
                        </li>
                    ))
                }
            </ul>
        )
    }


    render() {
        return (
            <>
                <section class="mt-navbar shadow-sm">
                    {this.customBeerLine()}
                </section>
                <section class="py-5 light-bg">
                    {this.pictureList()}
                </section>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    // console.log('maping state', state);
    return {
        imageState: state,
    }
}

const mapDispatchToProps = {
    fetchImages
}
export default connect(mapStateToProps, mapDispatchToProps)(BeerLine);